export const Bio = {
  name: "Yathreb SAMAALI",
  roles: [
    "Full Stack Developer",
    "AI Developer"
  ],
  description:
  "A Full-Stack and AI Developer passionate about building intelligent, scalable, and user-centric applications. I integrate modern web technologies with AI to deliver high-performance digital solutions.",
  github: "https://github.com/YathrebSamaali",
  resume:"https://drive.google.com/file/d/1DQLuPs1Kj-N8HN1kPHh5npzhDtyTU4Le/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/yathreb-samaali-0986a9241/",
  insta: "https://www.instagram.com/yathreb_samaali_/",
  facebook: "https://www.facebook.com/yathreb.samali/",
};

export const skills = [
  {
    title: "Front-End",
    skills: [
      {
        name: "Angular",
        image: "https://angular.io/assets/images/logos/angular/angular.svg",
      },
      
      {
        name: "React.js",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      },
      {
        name: "HTML5",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
      },
      {
        name: "CSS3",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
      },
      {
        name: "JavaScript",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      },
      {
        name: "TypeScript",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
      },
      {
        name: "Bootstrap",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg",
      },
     
    ],
  },
  {
    title: "Back-End ",
    skills: [
      {
        name: "Spring Boot",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg",
      },
      {
        name: "Node.js",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
      },
      {
        name: "Express.js",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
      },
      {
        name: "Laravel",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/laravel/laravel-original.svg",
      },
      {
        name: "MySQL",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
      },
      {
        name: "PostgreSQL",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg",
      },
      {
        name: "MongoDB",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
      },
      
    ],
  },
{
  title: "AI & Machine Learning",
  skills: [
    {
      name: "Python",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
    },
    {
      name: "TensorFlow",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg",
    },
    {
      name: "PyTorch",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pytorch/pytorch-original.svg",
    },
    {
      name: "Keras",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/keras/keras-original.svg",
    },
    {
      name: "Scikit-Learn",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/scikitlearn/scikitlearn-original.svg",
    },
    {
      name: "Pandas",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pandas/pandas-original.svg",
    },
    {
      name: "NumPy",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/numpy/numpy-original.svg",
    },
    {
      name: "OpenCV",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/opencv/opencv-original.svg",
    },
  {
  name: "YOLO",
  image: "https://www.electronics-engineering.com/wp-content/uploads/2024/06/3hql0qh3b7.png",
}
,
    {
  name: "Hugging Face",
  image: "https://huggingface.co/front/assets/huggingface_logo.svg",
},
    {
      name: "Google Colab",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/googlecolab/googlecolab-original.svg",
    },
    {
      name: "Jupyter Notebook",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jupyter/jupyter-original.svg",
    }
  ],
},

  {
  title: "DevOps",
  skills: [
    {
      name: "Linux",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linux/linux-original.svg",
    },
    {
      name: "Docker",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
    },
    {
      name: "AWS",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
    },
    {
      name: "Jenkins (CI/CD)",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg",
    },
    {
      name: "SonarQube",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sonarqube/sonarqube-original.svg",
    },  
    {
      name: "JUnit",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/junit/junit-original.svg",
    },
    {
      name: "Prometheus",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/prometheus/prometheus-original.svg",
    },
    {
      name: "Grafana",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/grafana/grafana-original.svg",
    },
    {
      name: "NGINX",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nginx/nginx-original.svg",
    },
    {
      name: "Apache",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apache/apache-original.svg",
    },
    {
      name: "Terraform",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/terraform/terraform-original.svg",
    },
    {
      name: "Kubernetes",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-original.svg",
    },
  ],
},

  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
      },
      {
        name: "GitHub",
        image: "https://icones.pro/wp-content/uploads/2021/06/icone-github-grise.png",
      },
      {
        name: "VS Code",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg",
      },
      
      {
      name: "Netlify",
      image: "https://cdn.worldvectorlogo.com/logos/netlify.svg",
    },
    {
      name: "Vercel",
      image: "https://www.svgrepo.com/show/361653/vercel-logo.svg",
    },
    {
        name: "Postman",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postman/postman-original.svg",
      },
      {
      name: "Jira",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jira/jira-original.svg",
    },
      {
        name: "Figma",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",
      },
      {
  name: "Power BI",
  image: "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/power-bi-icon.png",
}
,

    ],
  },
{
  title: "Soft Skills",
  skills: [
    {
      name: "Teamwork",
      image: "https://img.icons8.com/color/48/000000/teamwork.png",
    },
    {
      name: "Communication",
      image: "https://img.icons8.com/color/48/000000/communication.png",
    },
    {
      name: "Problem Solving",
      image: "https://cdn-icons-png.flaticon.com/512/6487/6487594.png",
    },
    {
      name: "Adaptability",
      image: "https://cdn-icons-png.flaticon.com/512/10108/10108220.png",
    },
    {
      name: "Leadership",
      image: "https://cdn-icons-png.flaticon.com/512/9217/9217572.png",
    },
    {
      name: "Time Management",
      image: "https://cdn-icons-png.flaticon.com/512/9815/9815843.png",
    },
  ],
}


];


export const experiences = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/v2/D4E0BAQGkVCmjaJqevg/company-logo_200_200/company-logo_200_200/0/1681685425208/tech4iot_logo?e=2147483647&v=beta&t=5qkcs0Vx-OWBzBMHF3s1E231w4S3dcPJuQnUj1JzGh8",
    role: "Hybrid ML Model for Fish Species Detection in Aquaculture | AI Intern",
    company: "Tech4Iot",
    date: "Jan 2024 - Apr 2024",
    desc: "This project aims to develop a hybrid Machine Learning model for fish species detection in aquaculture, combining the strengths of RCNN and YOLOv5 models to achieve more precise and reliable detection, even in variable conditions.",
    skills: [
      "Deep Learning",
      "Objets Detection",
      "YOLOv5",
      "RCNN",
      "Python",
      "Model fusion",
      "TensorFlow",
      "PyTorch", "OpenCV",
    ],
    doc: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRcnr8j3ppWJ7OIzcmR8NJ4IfrEtZR5h3PQXg&s",
  },
  {
    id: 1,
    img: "https://media.licdn.com/dms/image/v2/D4E0BAQFrn9b1hSXBJQ/company-logo_200_200/company-logo_200_200/0/1725032424883/actia_corporation_logo?e=2147483647&v=beta&t=pD2lQRmGxqWe9Zt1zng5OGxT1CY5Yu6yfzJpQHwfrYY",
    role: "Web application for screen printing usage traceability | Fullstack Intern",
    company: "CIPI ACTIA",
    date: "Jun 2023 - Jul 2023",
    desc: "Development of a web application to ensure the traceability of screen printing usage, intended for internal use within the company, allowing for efficient and transparent tracking and management of screen usage.",
    skills: [
      "Laravel",
"Bootstrap",
"HTML",
"CSS",
"JS",
"PostgreSQL",

    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1696514649120.jpeg?alt=media&token=e7f6757b-edfa-4138-a692-d6709eeef3e2",
  },
];

export const education = [

  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRLFYKxh7ryZrM3mWNqOZLRnHaeCPgZTZ4fQdBcunxkgJ1aLNWNj_q6D8X83duuytpJyGg&usqp=CAU",
    school: "Master's in Intelligent Web Applications",
    date: "Dec 2024 - Jun 2026",
    desc: "Currently pursuing a Master’s degree in Intelligent Web Applications, focusing on the design and development of dynamic, intelligent web applications that leverage artificial intelligence and data-driven technologies to deliver innovative solutions.",
    degree: "Higher Institute of Computer Science Kef",
  },

  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRLFYKxh7ryZrM3mWNqOZLRnHaeCPgZTZ4fQdBcunxkgJ1aLNWNj_q6D8X83duuytpJyGg&usqp=CAU",
    school: "Bachelor's Degree in Software Engineering and Information Systems",
    date: "Dec 2021 - Jun 2024",
    desc: "Completed a comprehensive education in software engineering and information systems, gaining both theoretical knowledge and practical skills, with a solid foundation in programming, system architecture, and problem-solving.",
    degree: "Higher Institute of Computer Science Kef",
  },
];

export const projects = [
  
 
  

  {
    id: 1,
    title: "PRM-25 ",
    date: "DEC 2025",
    description:
      "Backend of the PRM-25 application built with Spring Boot, Java 17, and MySQL. Handles authentication, authorization, and data management for property management system.",
    image:
      "https://images.unsplash.com/photo-1555949963-aa79dcee981c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    tags: [
      "Spring Boot",
      "Java 17",
      "MySQL",
      "Postman",
      "Maven",
      "REST API",
      "Authentication"
    ],
    category: "web app",
    github: "https://github.com/YathrebSamaali/PRM-25.git",
  },
  {
    id: 2,
    title: "PowerBI Forecasting Project",
    date: "NOV 2025",
    description:
      "A BI project using Python and Power BI for data cleaning, analysis, and sales forecasting with Prophet. Outputs are ready for interactive dashboards with KPIs, charts, and filters.",
    image:"https://github.com/YathrebSamaali/PowerBI-Forecasting-Project/blob/main/screenshots/sales_dashboard.png?raw=true",
    tags: [
      "Python",
      "Power BI",
      "Prophet",
      "Data Analysis",
      "Forecasting",
  "KPI",
  "Interactive Dashboard"
    ],
    category: "machine learning",
    github: "https://github.com/YathrebSamaali/PowerBI-Forecasting-Project",
  },
  {
    id: 3,
    title: "DevOps Pipeline Project",
    date: "OCT 2025",
    description:
      "This project is a Spring Boot application developed to manage the activities of a ski resort. It includes management of slopes, courses, instructors, subscriptions, and skiers. The goal is to provide a modular and maintainable architecture, ready to be integrated into a DevOps pipeline for automated deployment and testing.",
    image:
      "https://i.ytimg.com/vi/EzgCoOQvOf0/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLAs2nVWGk0CAEdN_1UPtq289oShlA",
    tags: [
      "Spring Boot",
      "Angular",
      "Docker",
      "CI/CD",
      "SonarQube",
      "Grafana",
      "Prometheus",
      "Nexus",
      "Kubernetes",
      "Terraform",
      "AWS"
    ],
    category: "web app",
    github: "https://github.com/YathrebSamaali/devops-pipeline-project.git",
  },
  {
    id: 4,
    title: "CNN Image Classifier",
    date: "SEP 2025",
    description:
      "A web app for real-time image classification using a deep learning model trained on CIFAR-10. Supports 10 categories, shows confidence scores, and features a modern responsive UI.",
    image:
      "https://github.com/YathrebSamaali/Application-CNN/blob/main/static/screenshot1.png?raw=true",
    tags: [
      "Python",
      "ML",
      "VGG16",
      "CNN",
      "Image Classification",
      "TensorFlow",
  "Keras"
    ],
    category: "machine learning",
    github: "https://github.com/YathrebSamaali/Application-CNN",
  },
  {
    id: 5,
    title: "SmartShop",
    date: "MAR 2025",
    description:
  "SmartShop is an e-commerce web application built with Laravel, featuring separate **user and admin interfaces**. It provides a robust platform for managing products, orders, and customers, supporting all the essential functionalities required for an online store.",
    image:
      "https://github.com/YathrebSamaali/SmartShop/blob/main/screenshots/1.PNG?raw=true",
    tags: [
      "Laravel",
      "MySQL",
      "E-commerce",
      "Blade Templates"
    ],
    category: "web app",
    github: "https://github.com/YathrebSamaali/SmartShop.git",
  },
  
  {
    id: 6,
    title: "Car Price Predictor",
    date: "FEB 2025",
    description:
      "A Django web app that predicts the price of a car based on its features (year, mileage, brand, fuel type, transmission). It uses a machine learning model on the backend and a responsive frontend interface.",
    image:
      "https://www.inovex.de/wp-content/uploads/2019/02/Price-Prediction-in-Online-Car-Marketplaces.png",
    tags: [
      "Django",
      "PostgreSQL",
      "Python",
      "Machine Learning",
      "Regression"
    ],
    category: "machine learning",
    github: "https://github.com/YathrebSamaali/car-price-predictor.git",
  },
  {
    id: 7,
    title: "House Price Predictor",
    date: "JAN 2025",
    description:
      "A Streamlit web application that predicts house prices based on property features using machine learning. Features interactive UI and real-time predictions.",
    image:
      "https://miro.medium.com/1*JB1UtsoPA0xQI59JKyY2hA.jpeg",
    tags: [
      "Python",
      "Streamlit",
      "Machine Learning",
      "Regression",
      "Data Visualization"
    ],
    category: "machine learning",
    github: "https://github.com/YathrebSamaali/house-price-predictor.git",
  },
  {
    id: 8,
    title: "SmartHealth",
    date: "DEC 2024",
    description:
      "SmartHealth is a web application designed to predict potential diseases based on symptoms provided by the user. It combines the power of Django for the backend and Machine Learning for disease prediction.",
    image:
      "https://i.ytimg.com/vi/7Jzr1ZUjDSM/maxresdefault.jpg",
    tags: [
      "Django",
      "PostgreSQL",
      "Machine Learning",
      "Healthcare",
      "Prediction"
    ],
    category: "machine learning",
    github: "https://github.com/YathrebSamaali/SmartHealthPredictor.git",
  },
  
  {
    id: 9,
    title: "JobLink",
    date: "DEC 2024",
    description:
      "JobLink is a recruitment platform designed to simplify the connection between candidates and recruiters. It streamlines the hiring process by facilitating communication and job matching.",
    image:
      "https://media.licdn.com/dms/image/v2/D4E12AQE-482AcQmM3Q/article-cover_image-shrink_600_2000/article-cover_image-shrink_600_2000/0/1701620397545?e=2147483647&v=beta&t=iCUtoA0eKaZN7iWoRUZ51grGH1z3i7uzNya7YHF6M8Y",
    tags: [
      "Django",
      "PostgreSQL",
      "Machine Learning",
      "Recruitment",
      "Job Matching"
    ],
    category: "web app",
    github: "https://github.com/YathrebSamaali/JobLink.git",
  },

  {
    id: 10,
    title: "Multi-Document Chatbot",
    date: "JUL 2024",
    description:
      "An AI-powered chatbot built with Streamlit to answer questions from PDF, DOCX, and PPTX files. Utilizes LangChain for conversation management and FAISS for contextual search. Supports multi-document processing and intelligent Q&A.",
    image:
      "https://tubeonai.com/wp-content/uploads/2025/07/How-to-Chat-with-Any-Document-Using-AI.jpg",
    tags: [
      "Python",
      "Streamlit",
      "LangChain",
      "FAISS",
      "LLM",
      "Document Processing",
      "Chatbot"
    ],
    category: "machine learning",
    github: "https://github.com/YathrebSamaali/multi-document-chatbot.git",
  },
{
  id: 11,
  title: "Fish Species Detection",
  date: "JAN 2024",
  description: "This project combines two advanced computer vision approaches—Mask R-CNN for precise fish segmentation and YOLOv5 for high-speed real-time detection—to identify and monitor various fish species in images and videos. Mask R-CNN provides accurate segmentation, allowing detailed analysis of individual fish shapes and sizes, while YOLOv5 enables fast detection in dynamic aquatic environments. The combined approach automates the classification and counting of fish, supporting ecological monitoring, marine biodiversity studies, and sustainable resource management. This project offers the advantage of both precision and speed, making it ideal for researchers and conservation efforts that require reliable, large-scale fish monitoring.",
  image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSaMupK1lyxfyaPyj8-iZ5DHyW6bM8rCNPR9g&s",
  tags: [
  
    
    "Mask R-CNN",
    "YOLOv5",
    
    "Object Detection",
    "Marine Conservation",
    "Real-time Detection"
  ],
  category: "machine learning",
  github: "https://github.com/YathrebSamaali/fish_detection.git"
}

];

